module.exports = __webpack_public_path__ + "static/media/base_azul.8351c755.png";